export default __webpack_public_path__ + "static/14-7c6ecfcc5cc0fdf9dbd05a1224b2e188.png";